import { render, staticRenderFns } from "./OperateButtons.vue?vue&type=template&id=6cfac8a5&scoped=true"
import script from "./OperateButtons.vue?vue&type=script&lang=js"
export * from "./OperateButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfac8a5",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/template/components/OperateButtons.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FVolumes%2FSSD%2Fjenkins_workspace%2Fworkspace%2FJL_UAT_OPERATION%2Fsrc%2Fcomponents%2FOperateButtons.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports